
import { Component, mixins } from 'nuxt-property-decorator';
import { ContentBlockImageData, contentBlockImageSizeModifiersMap, LogosBlockModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';
import ContentBlockImage from './ContentBlockImage.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
  },
})
export default class LogosBlock extends mixins(ContentBlockMixin<LogosBlockModel>) {
  get blockClassNames(): Array<string | Record<string, boolean>> {
    return [
      contentBlockImageSizeModifiersMap[this.settings.logoSize],
      {
        '-with-border': this.settings.withLogoBorder,
      },
    ];
  }

  public getItemTagName(image: ContentBlockImageData): string {
    return image.link && image.link[this.$i18n.locale] ? 'a' : 'div';
  }

  public getItemAttributes(image: ContentBlockImageData): Record<string, string> {
    const attributes: Record<string, string> = {};

    if (image.link && image.link[this.$i18n.locale]) {
      attributes.href = image.link[this.$i18n.locale];
      attributes.target = '_blank';
      attributes.rel = 'noopener noreferrer';
    }

    return attributes;
  }
}
